import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["domNodeRef", "controlsRef"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { EnterViewportTracker } from "../../utility";
var getMaxScrollLeft = function getMaxScrollLeft(domNode) {
  return domNode.scrollWidth - domNode.clientWidth;
};

/**
 * HOC that enables drag behavior for scroll container
 */
export default function withAnimation(WrappedScrollContainer) {
  function WithAnimation(_ref) {
    var domNodeRef = _ref.domNodeRef,
      controlsRef = _ref.controlsRef,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    /** decipher controls */
    var linearScrollConfig = {
      easing: function easing(t) {
        return t;
      },
      duration: 600
    };
    var scrollTo = function scrollTo(position) {
      return controlsRef.current.scrollTo(position, {
        config: linearScrollConfig
      });
    };
    var animate = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var maxScroll;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              maxScroll = getMaxScrollLeft(domNodeRef.current);
              _context.next = 3;
              return scrollTo(Math.min(maxScroll, 350));
            case 3:
              scrollTo(0);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function animate() {
        return _ref2.apply(this, arguments);
      };
    }();
    return /*#__PURE__*/React.createElement(EnterViewportTracker, {
      domNodeRef: domNodeRef,
      onEnterViewport: animate,
      "data-t-id": "ScrollContainerV2-enhancers"
    }, /*#__PURE__*/React.createElement(WrappedScrollContainer, _extends({}, otherProps, {
      controlsRef: controlsRef,
      domNodeRef: domNodeRef,
      "data-t-id": "ScrollContainerV2-enhancers"
    })));
  }
  WithAnimation.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread({}, WrappedScrollContainer.propTypes) : {};
  if (process.env.NODE_ENV !== 'production') {
    WithAnimation.displayName = 'WithAnimation';
  }
  return WithAnimation;
}